module.exports = __webpack_public_path__ + "static/생활잡화-d9b4fca3b44f570c1b5392eb0fef606d.jpg";